import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './PurposeProfessionalsSection.module.scss';

export const PurposeProfessionalsSection: React.FC = () => {
    const { t } = useTranslation();

    const CARDS = [
        { title: t('landing.purposeProfessionals.cards.vision.title', 'Comparten una mirada'), desc: t('landing.purposeProfessionals.cards.vision.desc', 'Acompañan la salud desde una perspectiva humana, respetuosa e integrativa.') },
        { title: t('landing.purposeProfessionals.cards.dialogue.title', 'Valoran el diálogo'), desc: t('landing.purposeProfessionals.cards.dialogue.desc', 'Creen en la integración entre enfoques distintos y en el intercambio entre saberes.') },
        { title: t('landing.purposeProfessionals.cards.community.title', 'Buscan comunidad'), desc: t('landing.purposeProfessionals.cards.community.desc', 'Desean formar parte de una red colaborativa, menos aislada y con propósito compartido.') },
        { title: t('landing.purposeProfessionals.cards.network.title', 'Quieren crecer en red'), desc: t('landing.purposeProfessionals.cards.network.desc', 'Sienten que su práctica puede potenciarse dentro de un ecosistema más amplio y conectado.') }
    ];

    return (
        <section className={styles['purpose-section']}>
            <div className={styles['container']}>
                <div className={styles['top-row']}>
                    <div className={styles['col-left']}>
                        <p className={styles['eyebrow']}>{t('landing.purposeProfessionals.eyebrow', 'CONVOCATORIA')}</p>
                        <h2 className={styles['title']}>{t('landing.purposeProfessionals.title', 'Profesionales que\nacompañan con\npropósito')}</h2>
                    </div>
                    <div>
                        <p className={styles['description']}>{t('landing.purposeProfessionals.description', 'Esta propuesta está pensada para quienes buscan crecer en red sin perder profundidad, criterio ni sentido humano en su forma de acompañar.')}</p>
                    </div>
                </div>

                <div className={styles['cards-grid']}>
                    {CARDS.map((card, i) => (
                        <div key={i} className={styles['card']}>
                            <h3 className={styles['card-title']}>{card.title}</h3>
                            <p className={styles['card-desc']}>{card.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
